import { useEffect } from "react";
import { toast } from "sonner";

/** Listener globale per eventi 429 anti-abuso (burst o cap mensile).
 *
 * Quando l'interceptor in `lib/api.js` riceve un 429, dispatcha
 * `pronto:rate-limited` con un messaggio leggibile. Qui lo intercettiamo
 * e mostriamo un toast (de-duplicato a 1 ogni 4s per non spammare).
 */
let _lastShownAt = 0;
let _lastBudgetShownAt = 0;

export default function RateLimitToastListener() {
  useEffect(() => {
    const onRate = (e) => {
      const now = Date.now();
      if (now - _lastShownAt < 4000) return;
      _lastShownAt = now;
      const msg = e?.detail?.message || "Troppe richieste, riprova fra qualche minuto.";
      toast.error(msg, {
        duration: 6000,
        description: "Limite anti-abuso · serve a tenere i costi sotto controllo.",
      });
    };
    // iter 313 r14: budget GLOBALE LLM mensile esaurito.
    // iter 313 r15: non mostriamo numeri € all'utente.
    const onBudget = (e) => {
      const now = Date.now();
      if (now - _lastBudgetShownAt < 8000) return;
      _lastBudgetShownAt = now;
      const d = e?.detail || {};
      toast.error("Servizio temporaneamente in pausa", {
        duration: 12000,
        description: d.message || "Stiamo facendo un po' di manutenzione automatica. Riprova fra qualche ora oppure passa al piano Pro per accesso senza limiti.",
      });
    };
    window.addEventListener("pronto:rate-limited", onRate);
    window.addEventListener("pronto:global-budget-exceeded", onBudget);
    // iter v32 r28 — DISABILITATO il toast diagnostico 500.
    // Apple Reviewer iPad ha visto "500 · /live/history" come popup rosso e
    // ha respinto l'app (Guideline 2.1(a)). Il toast era una diagnostica
    // TEMPORANEA (iter v31 r18) mai rimossa. Il bug a monte (created_at int
    // invece di ISO string in auth_apple.py) è stato risolto: niente più
    // 500 a cascata per utenti Apple. Il listener resta registrato come
    // no-op per compat, ma non mostra più nulla all'utente finale.
    const on500 = (_e) => { /* silenziato in prod */ };
    window.addEventListener("pronto:server-error-500", on500);
    return () => {
      window.removeEventListener("pronto:rate-limited", onRate);
      window.removeEventListener("pronto:global-budget-exceeded", onBudget);
      window.removeEventListener("pronto:server-error-500", on500);
    };
  }, []);
  return null;
}
